import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  UpdatePlannerActions as Actions,
  UpdatePlannerRequestAction as RequestAction,
} from 'store/ducks/planners';

export function* updatePlannerRequest(action: any) {
  const { id, putData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.put, `planners/${id}`, putData);
    onSuccess && onSuccess();
    notify('success', 'Planejadores atualizado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
